import { Component, OnInit } from '@angular/core';
import { UserService } from '../model/user.service';
import { TokboxService } from '../model/tokbox.service';
import { User } from '../model/user';
import { Router } from '@angular/router';
import { toast } from 'angular2-materialize';
import '../../assets/tokbox/js/app.js';
import { EventBus } from '../shared/EventBus/EventBus';

declare var myExtObject: any;

@Component({
  templateUrl: './Product.component.html'
})

export class ProductComponent implements OnInit {
  Products: any[];
  LoginUserId: number;
  AgencyId: number;
  LocationId: number;
  ShowProductsLoader: boolean;
  users: User[] = [];
  ShowAvailAgentsLoader: boolean;
  ngOnInit() {
    if (this.userService.decodeToken().user.RoleId !== 3) {
      this.userService.RedirectAccToRole(this.userService.decodeToken().user.RoleId);
    }

    this.userService.GetInitialSettings(this.LoginUserId).subscribe((response) => {
      if (response && response.Data) {
        this._eventBus.emit({
          Type: 'header-left-statics',
          data: response.Data
        });
      }
    }, (error) => {
    });
  }


  constructor(private userService: UserService, private _router: Router, private tokboxService: TokboxService,
    private _eventBus: EventBus) {
    // get agency/user detail from token
    const UserModel = this.userService.decodeToken();
    if (UserModel && UserModel.user) {
      this.LoginUserId = UserModel.user.UserId;
      this.LocationId = UserModel.user.LocationId;
      this.AgencyId = UserModel.user.AgencyId;
      this.LocationId = UserModel.user.LocationId;
    }
    this.GetProducts();
  }
  // get all products agency
  public GetProducts() {
    this.ShowProductsLoader = true;
    this.userService.getproducts(this.AgencyId, false)
      .subscribe(
        result => {
          if (result.Status) {
            this.Products = result.Data;
          } else {
          }
          this.ShowProductsLoader = false;
        },
        error => {
          if (error.Message === 'Token expired') {
            localStorage.removeItem('frontend-token');
            localStorage.removeItem('StripeCust');
            this._router.navigate(['/login']);
          }
          this.ShowProductsLoader = false;
        }
      );
  }
  // get product detail by product Id
  public GetProductDetail(product) {
    this._router.navigate(['product/detail', product]);
  }
  // load all users
  public loadAllUsers(RoleId, OffSet) {
    this.ShowAvailAgentsLoader = true;
    this.userService.getAll(RoleId, OffSet, this.AgencyId, this.LocationId, false, '', '', '')
      .subscribe(
        result => {
          if (result.Status) {
            this.users = result.Data;
          } else {
          }
          this.ShowAvailAgentsLoader = false;
        },
        error => {
          if (error.Message === 'Token expired') {
            localStorage.removeItem('frontend-token');
            localStorage.removeItem('StripeCust');
            this._router.navigate(['/login']);
          }
          this.ShowAvailAgentsLoader = false;
        }
      );
  }

  public StartCall(ToUserId) {
    this.GenerateSessionIdAndTokenId(ToUserId);
  }

  public GenerateSessionIdAndTokenId(ToUserId) {
    const that = this;
    this.tokboxService.createsessionandtoken(this.LoginUserId, ToUserId)
      .subscribe(
        result => {
          if (result.Status) {
            myExtObject.start(result.sessionId, result.TokenId1, result.TokenId2, ToUserId, result.currentSessionId);
          } else {
            that.toasting(result.Message, 2000, 'red');
          }
        },
        error => {
          if (error.Message === 'Token expired') {
            localStorage.removeItem('frontend-token');
            localStorage.removeItem('StripeCust');
            this._router.navigate(['/login']);
          }
        }
      );
  }
  // show success/error message
  public toasting(text: string, duration: number = 3000, style: string) {
    toast(text, duration, style);
  }
}
